import { combineReducers } from 'redux';

// Import reducers
import activity from './modules/BusinessModelsMarketing/activity';
import behavior from './modules/GrowthPlan/behavior';
import beneficiary from './modules/ImpactPlan/beneficiary';
import beneficiaryTypes from './modules/ImpactPlan/beneficiaryTypes';
import businessModel from './modules/BusinessModelsMarketing/businessModel';
import chain from './modules/StakeholderMap/chain';
import channel from './modules/StakeholderMap/channel';
import comment from './modules/comment';
import competitor from './modules/CompetitionMap/competitor';
import emailDashboardMember from './modules/EmailDashboardMember';
import emailDashboardMentor from './modules/EmailDashboardMentor';
import expense from './modules/FinancialProjections/expense';
import financialProduct from './modules/FinancialProjections/financialProduct';
import financialProjection from './modules/FinancialProjections/financialProjection';
import fixedAsset from './modules/FinancialProjections/fixedAsset';
import funding from './modules/FinancialProjections/funding';
import growthRisk from './modules/GrowthPlan/growthRisk';
import initiative from './modules/GrowthPlan/initiative';
import interestship from './modules/Matching/interestship';
import investment from './modules/FinancialProjections/investment';
import IPresources from './modules/ImpactPlan/resource';
import keyResult from './modules/GrowthPlan/keyResult';
import member from './modules/member';
import memberApplication from './modules/memberApplication';
import mentor from './modules/mentor';
import mentorApplication from './modules/mentorApplication';
import metric from './modules/GrowthPlan/metric';
import milestone from './modules/GrowthPlan/milestone';
import moonshotGoal from './modules/GrowthPlan/moonshotGoal';
import notifications from './modules/notifications';
import objective from './modules/GrowthPlan/objective';
import { parrobotReducer } from './modules/parrobot/parrobotSlice';
import payroll from './modules/FinancialProjections/payroll';
import pills from './modules/Pills';
import pillsCategories from './modules/PillsCategories';
import pillsToolkit from './modules/PillsToolkit';
import pricingModel from './modules/PricingBusinessViability/pricingModel';
import product from './modules/product';
import profilePicture from './modules/profilePicture';
import program from './modules/program';
import programSetup from './modules/programSetup';
import programMentors from './modules/programMentors';
import programTools from './modules/programTools';
import programStats from './modules/programStats';
import programStep from './modules/programStep';
import project from './modules/project';
import projectSdg from './modules/ImpactPlan/projectSdg';
import relationships from './modules/ImpactPlan/relationship';
import resources from './modules/StakeholderMap/resources';
import result from './modules/ImpactPlan/result';
import retentionActivity from './modules/PricingBusinessViability/retentionActivity';
import riskCategory from './modules/GrowthPlan/riskCategory';
import role from './modules/ImpactPlan/role';
import rules from './modules/ImpactPlan/rule';
import organizationalRole from './modules/GrowthPlan/organizationalRole';
import scenario from './modules/scenario';
import sdg from './modules/ImpactPlan/sdg';
import sdgOutcome from './modules/ImpactPlan/outcome';
import sdgOutcomeIndicator from './modules/ImpactPlan/outcomeIndicator';
import sdgTarget from './modules/ImpactPlan/sdgTarget';
import segment from './modules/ValueProposition/segment';
import statusSummary from './modules/statusSummary';
import step from './modules/Tools/step';
import surveys from './modules/surveys';
import surveysResponses from './modules/surveyResponse';
import system from './modules/ImpactPlan/system';
import tool from './modules/Tools/tool';
import translations from './modules/translations';
import user from './modules/user';
import value from './modules/GrowthPlan/value';
import managementPanelMember from './modules/ManagementPanelMember';
import managementPanelMentor from './modules/ManagementPanelMentor';
import userSearch from './modules/userSearch';
import glossary from './modules/glossary';

// Tool PDF Stores
import stakeholderMapPdf from './modules/toolsPdf/StakeholderMap';
import competitionMapPdf from './modules/toolsPdf/CompetitionMap';
import businessModelsMarketingPdf from './modules/toolsPdf/BusinessModelsMarketing';
import pricingBusinessViabilityPdf from './modules/toolsPdf/PricingBusinessViability';
import financialProjectionsPdf from './modules/toolsPdf/FinancialProjections';
import impactPlanPdf from './modules/toolsPdf/ImpactPlan';
import growthPlanPdf from './modules/toolsPdf/GrowthPlan';

// Redux Toolkit - eventually all the reducers from above should be listed below
// API Slices
import { adminsApi } from 'services/apiSlices/adminsApi';
import { adminDashboardApi } from 'services/apiSlices/adminDashboardApi';
import { adminDashboardProgramsApi } from 'services/apiSlices/programs/adminDashboardProgramsApi';
import { areasOfExpertiseApi } from 'services/apiSlices/areasOfExpertiseApi';
import { areasOfInnovationApi } from 'services/apiSlices/areasOfInnovationApi';
import { countriesApi, publicCountriesApi, regionsAPI } from 'services/apiSlices/countriesApi';
import { customizationApi } from 'services/apiSlices/customizationApi';
import { entrepreneursApi } from 'services/apiSlices/entrepreneurApi';
import { entrepreneurApplicationApi } from 'services/apiSlices/applications/entrepreneurApplicationApi';
import { exploreProjectsApi } from 'services/apiSlices/projects/exploreProjectsApi';
import { interestshipsApi } from 'services/apiSlices/interestshipsApi';
import { invitesApi } from 'services/apiSlices/invitesApi';
import { languagesApi } from 'services/apiSlices/languagesApi';
import { communityProfilesApi } from 'services/apiSlices/communityProfilesApi';
import { userApi } from 'services/apiSlices/userApi';
import { accountApi } from 'services/apiSlices/accountApi';
import { managementPanelApi } from 'services/apiSlices/managementPanelApi';
import { mentorApplicationApi } from 'services/apiSlices/applications/mentorApplicationApi';
import { organizationsApi } from 'services/apiSlices/organizationsApi';
import { projectsApi } from 'services/apiSlices/projects/projectsApi';
import { programsApi } from 'services/apiSlices/programs/programsApi';
import { programsDashboardApi } from 'services/apiSlices/programsDashboardApi';
import { publicProgramsApi } from 'services/apiSlices/programs/publicProgramsApi';
import { publicProjectsApi } from 'services/apiSlices/projects/publicProjectsApi';
import { pillsApi } from 'services/apiSlices/pillsApi';
import { pillToolsApi } from 'services/apiSlices/pillToolsApi';
import { pillCategoriesApi } from 'services/apiSlices/pillCategoriesApi';
import { userTokenAPI } from 'services/apiSlices/userTokenApi';
import { demoTokenAPI } from 'services/apiSlices/demoTokenApi';
import { demoExamplesApi } from 'services/apiSlices/demoExamplesApi';
import { teamApi } from 'services/apiSlices/teamApi';
import { positioningsApi } from 'services/apiSlices/positionings/positioningsApi';
import { workspaceApi } from 'services/apiSlices/workspaceApi';
import { benefitApi } from 'services/apiSlices/benefitApi';
import { oauth2Api } from 'services/apiSlices/oauth2Api';
import { workExperienceApi } from 'services/apiSlices/workExperienceApi';
import { userLinkApi } from 'services/apiSlices/userLinkApi';
import { executiveSummaryApi } from 'services/apiSlices/executiveSummaryApi';
import { executiveSummaryMembersApi } from 'services/apiSlices/executiveSummaryMembersApi';
import { documentsApi } from 'services/apiSlices/documentsApi';
import { deepDiveApi } from 'services/apiSlices/deepDiveApi';
import { deepDiveLinkApi } from 'services/apiSlices/deepDiveLinkApi';
import { valuePropositionOutcomesApi } from 'services/apiSlices/valuePropositionOutcomeApi';
import { valuePropositionReasonsApi } from 'services/apiSlices/valuePropositionReasonApi';
import { valuePropositionPainsApi } from 'services/apiSlices/valuePropositionPainApi';
import { problemsApi } from 'services/apiSlices/problemApi';
import { educationExperienceApi } from 'services/apiSlices/educationExperienceApi';
import { featureApi } from 'services/apiSlices/featureApi';
import { attributeApi } from 'services/apiSlices/attributeApi';
import { stepsApi } from 'services/apiSlices/stepsApi';
import { partnersApi } from 'services/apiSlices/partnersApi';
import { organizationalRolesApi } from 'services/apiSlices/organizationalRolesApi';

// Non-API Slices
import customProgramLinkReducer from './modules/customProgramLink/customProgramLinkSlice';
import { applicationEntrepreneurReducer } from './modules/application/applicationEntrepreneurSlice';
import { applicationMentorReducer } from './modules/application/applicationMentorSlice';
import { ventureSummaryReducer } from './modules/application/ventureSummarySlice';
import { projectFinancialForecastReducer } from './modules/application/financialForecastSlice';
import applicationEntrepreneurSectionsReducer from 'store/modules/application/entrepreneurApplicationSectionsSlice';
import applicationMentorSectionsReducer from './modules/application/mentorApplicationSectionsSlice';
import { languagesReducer } from './modules/languages/languagesSlice';

const rootReducer = combineReducers({
  activity,
  behavior,
  beneficiary,
  beneficiaryTypes,
  businessModel,
  chain,
  channel,
  comment,
  competitor,
  emailDashboardMember,
  emailDashboardMentor,
  expense,
  financialProduct,
  financialProjection,
  fixedAsset,
  funding,
  growthRisk,
  initiative,
  interestship,
  investment,
  IPresources,
  keyResult,
  member,
  surveysResponses,
  memberApplication,
  mentor,
  mentorApplication,
  metric,
  milestone,
  moonshotGoal,
  notifications,
  objective,
  parrobot: parrobotReducer,
  payroll,
  pills,
  pillsCategories,
  pillsToolkit,
  pricingModel,
  product,
  profilePicture,
  program,
  programSetup,
  programMentors,
  programTools,
  programStats,
  programStep,
  project,
  projectSdg,
  relationships,
  resources,
  result,
  retentionActivity,
  riskCategory,
  role,
  rules,
  organizationalRole,
  scenario,
  sdg,
  sdgOutcome,
  sdgOutcomeIndicator,
  sdgTarget,
  segment,
  statusSummary,
  step,
  surveys,
  system,
  tool,
  translations,
  user,
  value,
  managementPanelMember,
  managementPanelMentor,
  glossary,
  // Tool PDF Stores
  stakeholderMapPdf,
  competitionMapPdf,
  businessModelsMarketingPdf,
  pricingBusinessViabilityPdf,
  financialProjectionsPdf,
  impactPlanPdf,
  growthPlanPdf,
  // API Slices
  [adminsApi.reducerPath]: adminsApi.reducer,
  [adminDashboardApi.reducerPath]: adminDashboardApi.reducer,
  [adminDashboardProgramsApi.reducerPath]: adminDashboardProgramsApi.reducer,
  [areasOfExpertiseApi.reducerPath]: areasOfExpertiseApi.reducer,
  [areasOfInnovationApi.reducerPath]: areasOfInnovationApi.reducer,
  [countriesApi.reducerPath]: countriesApi.reducer,
  [publicCountriesApi.reducerPath]: publicCountriesApi.reducer,
  [regionsAPI.reducerPath]: regionsAPI.reducer,
  [customizationApi.reducerPath]: customizationApi.reducer,
  [entrepreneursApi.reducerPath]: entrepreneursApi.reducer,
  [entrepreneurApplicationApi.reducerPath]: entrepreneurApplicationApi.reducer,
  [exploreProjectsApi.reducerPath]: exploreProjectsApi.reducer,
  [interestshipsApi.reducerPath]: interestshipsApi.reducer,
  [invitesApi.reducerPath]: invitesApi.reducer,
  [languagesApi.reducerPath]: languagesApi.reducer,
  [communityProfilesApi.reducerPath]: communityProfilesApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [accountApi.reducerPath]: accountApi.reducer,
  [managementPanelApi.reducerPath]: managementPanelApi.reducer,
  [mentorApplicationApi.reducerPath]: mentorApplicationApi.reducer,
  [organizationsApi.reducerPath]: organizationsApi.reducer,
  [projectsApi.reducerPath]: projectsApi.reducer,
  [programsApi.reducerPath]: programsApi.reducer,
  [programsDashboardApi.reducerPath]: programsDashboardApi.reducer,
  [publicProgramsApi.reducerPath]: publicProgramsApi.reducer,
  [publicProjectsApi.reducerPath]: publicProjectsApi.reducer,
  [pillsApi.reducerPath]: pillsApi.reducer,
  [pillToolsApi.reducerPath]: pillToolsApi.reducer,
  [pillCategoriesApi.reducerPath]: pillCategoriesApi.reducer,
  [teamApi.reducerPath]: teamApi.reducer,
  [userTokenAPI.reducerPath]: userTokenAPI.reducer,
  [demoTokenAPI.reducerPath]: demoTokenAPI.reducer,
  [demoExamplesApi.reducerPath]: demoExamplesApi.reducer,
  [positioningsApi.reducerPath]: positioningsApi.reducer,
  [workspaceApi.reducerPath]: workspaceApi.reducer,
  [benefitApi.reducerPath]: benefitApi.reducer,
  [oauth2Api.reducerPath]: oauth2Api.reducer,
  [workExperienceApi.reducerPath]: workExperienceApi.reducer,
  [userLinkApi.reducerPath]: userLinkApi.reducer,
  [executiveSummaryApi.reducerPath]: executiveSummaryApi.reducer,
  [executiveSummaryMembersApi.reducerPath]: executiveSummaryMembersApi.reducer,
  [documentsApi.reducerPath]: documentsApi.reducer,
  [deepDiveApi.reducerPath]: deepDiveApi.reducer,
  [deepDiveLinkApi.reducerPath]: deepDiveLinkApi.reducer,
  [valuePropositionOutcomesApi.reducerPath]: valuePropositionOutcomesApi.reducer,
  [valuePropositionReasonsApi.reducerPath]: valuePropositionReasonsApi.reducer,
  [valuePropositionPainsApi.reducerPath]: valuePropositionPainsApi.reducer,
  [problemsApi.reducerPath]: problemsApi.reducer,
  [educationExperienceApi.reducerPath]: educationExperienceApi.reducer,
  [featureApi.reducerPath]: featureApi.reducer,
  [attributeApi.reducerPath]: attributeApi.reducer,
  [stepsApi.reducerPath]: stepsApi.reducer,
  [partnersApi.reducerPath]: partnersApi.reducer,
  [organizationalRolesApi.reducerPath]: organizationalRolesApi.reducer,

  // Custom Slices (not API)
  customProgramLink: customProgramLinkReducer,
  applicationEntrepreneurSections: applicationEntrepreneurSectionsReducer,
  applicationMentorSections: applicationMentorSectionsReducer,
  applicationMentor: applicationMentorReducer, // calling it mentorApplication will throw a duplicate key error since we already have a mentorApplication above
  applicationEntrepreneur: applicationEntrepreneurReducer,
  ventureSummary: ventureSummaryReducer,
  FinancialForecast: projectFinancialForecastReducer,
  languages: languagesReducer,
  userSearch,
});

export default rootReducer;
